module.exports = __webpack_public_path__ + "static/media/Merfolk-Selected.94f4c78b.png";